import { FC, ReactNode } from 'react';

type AlexaFunctionCardProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export const AlexaFunctionCard: FC<AlexaFunctionCardProps> = ({
  children,
  description,
  title,
}) => (
  <div className="rounded-md border border-gray-200 bg-white p-4 shadow-sm">
    <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
    <p className="mt-1 text-sm text-gray-500">{description}</p>
    <div className="mt-3">{children}</div>
  </div>
);
